/*
 * 统计页面公共工具
 */
import XLSX from "xlsx";

// 数字格式化（千分位，最多 d 位小数）
export function fmt(n, d = 1) {
  if (n === null || n === undefined || isNaN(n)) return "-";
  return Number(n).toLocaleString("en-US", {
    maximumFractionDigits: d,
    minimumFractionDigits: 0,
  });
}

// 秒 -> 小时
export function secToHours(sec) {
  return Math.round((sec / 3600) * 10) / 10;
}

// 秒 -> "10 小时 14 分"（组件内配合 $t('chi106')/$t('chi107') 使用）
export function splitDuration(sec) {
  const h = Math.floor(sec / 3600);
  const m = Math.round((sec % 3600) / 60);
  return { h, m };
}

// 导出 Excel（rows：二维数组，同旧页面 XLSX.utils.aoa_to_sheet 用法）
export function exportExcel(rows, filename) {
  const ws = XLSX.utils.aoa_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
  XLSX.writeFile(wb, filename);
}

